import React from "react";
import { ShieldCheck, BadgeCheck, Globe, Lock } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function VerifiedSupplierTrustBadges() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const badges = [{
    icon: ShieldCheck,
    label: "ISO 9001:2015"
  }, {
    icon: BadgeCheck,
    label: "CE Certified"
  }, {
    icon: Globe,
    label: "RoHS Compliant"
  }, {
    icon: Lock,
    label: "TIA/EIA Standards"
  }];
  return <section data-section-id="38115" id="quality-benchmarks" className="dark bg-background text-foreground py-12">
      {}
      <div className="bg-card/40 backdrop-blur-md border-y border-border/50">
        <div ref={ref} className={`container mx-auto px-4 py-10 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
            {badges.map((badge, i) => <div key={i} data-index={i} className="flex flex-col items-center justify-center text-center gap-4 group">
                <div className="p-4 rounded-xl bg-background/50 border border-border/40 shadow-sm group-hover:border-primary/40 group-hover:shadow-[0_0_20px_rgba(0,255,255,0.15)] transition-all duration-300">
                  <badge.icon className="w-8 h-8 text-muted-foreground/40 group-hover:text-primary transition-all duration-300" strokeWidth={1.2} />
                </div>
                <span className="text-xs md:text-sm font-mono tracking-widest uppercase text-muted-foreground/60 group-hover:text-foreground transition-colors duration-300">
                  {badge.label}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}